(() => {
  if (window.flatsonsV24VideoReady) return;
  window.flatsonsV24VideoReady = true;

  document.addEventListener('click', (event) => {
    const galleryTrigger = event.target.closest('[data-gallery-src]');
    if (galleryTrigger) {
      const gallery = galleryTrigger.closest('[data-product-gallery]');
      const galleryImage = gallery?.querySelector('[data-gallery-main]');
      if (galleryImage) {
        galleryImage.removeAttribute('srcset');
        galleryImage.src = galleryTrigger.dataset.gallerySrc;
        galleryImage.alt = galleryTrigger.dataset.galleryAlt || galleryImage.alt;
      }
      gallery?.querySelectorAll('[data-gallery-src]').forEach((item) => {
        const isActive = item === galleryTrigger;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });
    }

    const trigger = event.target.closest('[data-v24-video-trigger]');
    if (!trigger) return;

    const frame = trigger.closest('[data-v24-external-video]');
    const source = trigger.dataset.videoSrc;
    if (!frame || !source) return;

    const iframe = document.createElement('iframe');
    iframe.src = source;
    iframe.title = trigger.dataset.videoTitle || 'Product video';
    iframe.loading = 'lazy';
    iframe.allow = 'encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    frame.replaceChildren(iframe);
    iframe.focus();
  });
})();
